import MonicaAlternativePage from '@/components/Pages/MonicaAlternativePage';

export default MonicaAlternativePage;
